import { PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import FlagStore from '../FlagStore';
import FuseSelectStore from '../FuseSelectStore';

const DEFAULT_VALUES = {
    groups: [],
    roles: [],
};

export default class RoleAccessModalStore {
    static PropType = PropTypes.shape({
        roles: MobxPropTypes.arrayOrObservableArrayOf(PropTypes.shape({
            value: PropTypes.string.isRequired,
            groupsSelect: FuseSelectStore.PropType.isRequired,
        })).isRequired,

        modal: FlagStore.PropType.isRequired,

        setValue: PropTypes.func.isRequired,
        getValue: PropTypes.func.isRequired,
        hasChanged: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class RoleAccessModalStore */{
            roles: [],

            originalValue: {},

            modal: new FlagStore(),
            exitConfirmationModal: new FlagStore(false),
        }, data);
    }

    setValue = action((value) => {
        value = { ...DEFAULT_VALUES, ...value };
        this.originalValue = value;
        this.roles.replace(value.roles.map((role) => ({
            value: role.value,
            groupsSelect: new FuseSelectStore({
                options: value.groups.map((group) => ({ label: group.name, value: group.id, hidden: group.unsync })),
                selectedValues: role.groups.map((group) => group.id),
            }),
        })));
    });

    updateGroups = action((role, groups) => {
        role.groupsSelect.setOptions(groups.map((group) => ({ label: group.name, value: group.id })));
    });

    getValue = () => ({
        roles: this.roles.map((role) => ({
            value: role.value,
            groups: role.groupsSelect.options
                .filter((option) => role.groupsSelect.selectedValues.some((value) => value === option.value))
                .map((option) => ({ name: option.label, id: option.value, unsync: option.hidden })),
        })),
    });

    hasChanged = () => this.originalValue.roles && (
        this.roles.some((role, roleIndex) => {
            const originalRole = this.originalValue.roles[roleIndex];
            return role.groupsSelect.selectedValues.length !== originalRole.groups.length ||
                role.groupsSelect.selectedValues
                    .some((value, groupIndex) => value !== originalRole.groups[groupIndex].id);
        }));

    close = action(() => {
        if (this.hasChanged()) {
            this.exitConfirmationModal.open();
        } else {
            this.modal.close();
        }
    });
}
